function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PictureComponent from "components/core/picture/picture-component";
import { StyledReviewCardComponent } from "./review-card-reviews-component.scss";
const ReviewCardComponent = ({ reviewCardProps })=>{
    const { image, subtitle, title } = reviewCardProps;
    return /*#__PURE__*/ _jsxs(StyledReviewCardComponent, {
        className: "card",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "top-image",
                children: /*#__PURE__*/ _jsx(PictureComponent, _object_spread({}, image))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "title",
                children: title
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "subtitle",
                children: subtitle
            })
        ]
    });
};
export default ReviewCardComponent;
